import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DropdownFilterService } from 'src/app/services/index-service';

@Component({
	selector: 'app-region-filter',
	template: `
		<div>
		<app-select-filter 
			[hasIcon] = "hasIcon"
			bindLabel = "name"
			bindValue = "id"
			placeholder = "Select Region"
			[label] = "label"
			[clearable]="multiple"
			[multiple] = "multiple"
			[items] = "metadata.data"
			[(value)] = value
			(valueChange)="valueChange.emit(value)"
		>
		</app-select-filter>
		</div>
    `,
})

export class AppRegionFilterComponent implements OnInit {
	@Input() value: any = null;
	@Output() valueChange = new EventEmitter();
	@Input() hasIcon = false;
	@Input() hasAllOption = true;
	@Input() multiple = false;
	@Input() hasDefault = false;
	@Input() label = 'Region';
	metadata = {
		data: [],
		limit: 100,
		total: 0,
		search: '',
	}
	constructor(private dropdownFilter: DropdownFilterService) { }

	ngOnInit() {
		this.getRegions();
	}

	getRegions() {
		let mtd = this.metadata;
		if (!mtd.data.length || mtd.data.length < mtd.total) {
			this.dropdownFilter
				.getRegions()
				.subscribe((res: any) => {
					const mappedData = (res.data || []).map(d => {
						return {
							id: d.id,
							name: d.name,
						}
					})
					mtd.data = [...mtd.data, ...mappedData];
					mtd.total = res.metadata.total;

					if (mtd.data.length && mtd.data.length < mtd.total) this.getRegions();
					else {
						if (this.hasAllOption && !this.multiple) {
							mtd.data.unshift({
								id: '',
								name: 'All',
							});
						}

						if (!this.multiple) {
							this.value = this.value || mtd.data[0].id;
							this.valueChange.emit(this.value);
						}

						if (this.multiple && this.hasDefault) {
							this.value = [mtd.data[0].id];
							this.valueChange.emit(this.value);
						}
					}
				});
		}

	}
}